import React from 'react';
import { useParams } from 'react-router-dom';
import { useTemplateRequestData } from '@/vacancy_request/components/template-request-form/hooks/use-requests';
import { HrFlexContainer, HrPrimary, Spinner } from '@components/styles/hr-styles';
import { formatDataToBulkOnForm } from '@/vacancy_request/components/template-request-form/utils';
import { TemplateRequestForm } from '@/vacancy_request/components/template-request-form';
import {
  BackgroundOverlay,
  ContentContainer,
  TitleForm
} from '@/vacancy_request/components/template-request-form/styled';
import { useTranslationWithPrefix } from '@/i18n/hooks';
import { ErrorMessage } from '@components/v1/ErrorMessage';
import { HrIconButton, HrSecondary } from '@components/styles/hr-styles';

const ViewTemplateRequest = () => {
  const { id: templateId } = useParams();
  const { data: templateRequestData, isLoading, error } = useTemplateRequestData(templateId);
  const { t } = useTranslationWithPrefix('requestVacancies.requestTemplate.form');

  if (isLoading)
    return (
      <HrFlexContainer justifyContent='center'>
        <Spinner className='hr-Charge' style={{ margin: '0 auto', fontSize: '24px', color: HrPrimary }} />
      </HrFlexContainer>
    );

  if (error) return <ErrorMessage icon='hr-Alert' message={t('messages.error.requestError')} />;

  const formValues = formatDataToBulkOnForm(templateRequestData);

  return (
    <>
      {/* Fondo con dos colores */}
      <BackgroundOverlay />

      {/* Contenido principal */}
      <ContentContainer>
        <TitleForm>
          <HrIconButton
            fontSize='24px'
            color={HrSecondary}
            className='hr-Carret-left'
            onClick={() => {
              window.location.href = '/app/configuration/vacancy_request';
            }}
            style={{ marginRight: '8px', cursor: 'pointer' }}
          />
          {t('titles.view')}
        </TitleForm>

        <TemplateRequestForm mode='view' formValues={formValues} couldBeDraft={false} />
      </ContentContainer>
    </>
  );
};

ViewTemplateRequest.propTypes = {};

export default ViewTemplateRequest;
